let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("sz5JF")).then(() => parcelRequire('bMVZ7'));